module.exports = __webpack_public_path__ + "static/overview02-7752adaea2faeb3068925984a0dfe6cd.jpg";